import { FileText, Search, X } from 'lucide-react';
import { useDocsStore } from '../../stores/docsStore';
import { Spinner } from '../common/Spinner';
import { EmptyState } from '../common/EmptyState';

export function DocsSearchResults() {
  const { searchQuery, searchResults, searching, clearSearch, navigateToPath } = useDocsStore();

  const handleSelect = (filePath: string) => {
    clearSearch();
    navigateToPath(filePath);
  };

  if (searching) {
    return (
      <div className="flex items-center justify-center py-8">
        <Spinner size="sm" />
      </div>
    );
  }

  if (searchResults.length === 0) {
    return (
      <div className="p-4">
        <EmptyState
          icon={<Search />}
          title="No results"
          description={`No .md files matching "${searchQuery}".`}
        />
      </div>
    );
  }

  return (
    <div className="py-1">
      <div className="flex items-center justify-between px-3 py-1.5">
        <span className="text-[10px] text-text-muted">
          {searchResults.length} result{searchResults.length !== 1 ? 's' : ''}
        </span>
        <button
          onClick={clearSearch}
          className="text-text-muted hover:text-text-primary"
          title="Clear search"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
      {searchResults.map((result) => {
        // Show a shortened directory path
        const dirDisplay = result.directory
          .replace('/opt/union-threads/', '')
          .replace('/var/lib/docker/volumes/ut-secondbrain_workspace-data/_data/', 'SB:');

        return (
          <button
            key={result.path}
            onClick={() => handleSelect(result.path)}
            className="w-full flex items-start gap-2 px-3 py-1.5 text-left hover:bg-bg-tertiary rounded transition-colors"
          >
            <FileText className="h-3.5 w-3.5 flex-shrink-0 mt-0.5 text-text-muted" />
            <div className="min-w-0">
              <div className="text-xs text-text-primary truncate">{result.name}</div>
              <div className="text-[10px] text-text-muted truncate">{dirDisplay}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}

export default DocsSearchResults;
